export enum BASE_UNITS {
    SIZE = 'px',
}
